import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

export interface DeleteConfirmationModalProps {
  onClose: () => void
  onSubmit: () => void
}

const DeleteConfirmationModal = ({ onClose, onSubmit }: DeleteConfirmationModalProps) => {
  return (
    <Modal
      illustration={'delete-cross'}
      title={i18n.t('project_management.schedule.sidepanel.delete_confirmation.title')}
      description={i18n.t('project_management.schedule.sidepanel.delete_confirmation.description')}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" onClick={onSubmit}>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(DeleteConfirmationModal)
